import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>About Us</h2>
        <p>
          At LifeStance, patient care is paramount – the driving force in
          everything we do. LifeStance is committed to state-of-the-art clinical
          excellence, to partnership and collaboration with other treating
          health care providers to ensure continuity of care, to the utilization
          of data to individually tailor services for continual improvement in
          outcomes, and to empowering patients to make informed choices and help
          them achieve their goals. This is offered in a compassionate and safe
          environment that provides education, support, and best practices in
          integrated care.
        </p>
        <p>
          LifeStance is a national provider of mental healthcare services with
          operations across the country. Founded in 2017, LifeStance brings
          together psychiatrists, psychologists, nurse practitioners, and
          licensed therapists to provide comprehensive mental health treatment
          services for patients of all ages. We believe there’s no
          one-size-fits-all approach to mental health.
        </p>

        <a
          href="https://g.co/kgs/zkc2Ssf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Our Eugene Location
        </a>

        <br />
        <br />

        <a
          href="https://g.co/kgs/nDFE3cM"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Our Corvallis Location
        </a>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
